import styled from 'styled-components'
import media from 'styled-media-query'

import { customMedia } from '../../utils/breakpoints'

import { Logo } from './Logo'


export const MainFooterContainer = styled.div`
 background: ${props => props.theme.footer.desktop.menu.background};
`

export const FooterSection = styled.div`
  .mobile {
    display: none;
  }

  ${customMedia.lessThan('sm')`
    .accordion__button {
      cursor: pointer;
      color: ${props => props.theme.footer.mobile.menu.title};
    }
    .accordion__panel {
      background-color: #DFE1E7;
      margin-left: calc(-50vw + 50%);
      width: 100vw;
      padding-top: 20px;
      padding-bottom: 1px;
      margin-bottom: 20px;
    }

    .accordion__button[aria-expanded='true']::after, .accordion__button[aria-selected='true']::after {
      transform: rotate(-135deg);
    }

    .accordion__heading {
      height: 62px;
    }

    .accordion__button:after {
        display: inline-block;
        content: '';
        height: 7px;
        width: 7px;
        margin-right: 12px;
        border-bottom: 2px solid currentColor;
        border-right: 2px solid currentColor;
        transform: rotate(45deg);
        margin-left: 10px;
    }

    .mobile {
      display: block;
    }
    .desktop{
      display: none;
    }
  `}
`

export const FooterSectionCopiryght = styled.div`
  padding: 43px 0 0 0;
  background-color: ${props => props.theme.footer.desktop.copyright.background};

  ${customMedia.lessThan('sm')`
    background-color: ${props => props.theme.footer.mobile.copyright.background};
    padding: 0 0 0 110px;
  `}

  ${customMedia.lessThan('xs')`
    padding: 0 0 0 24px;
  `}
`

export const FooterContainer = styled.div`
  padding: 72px 136px 0 136px;

  ${customMedia.greaterThan('lg')`
    max-width: 1100px;
    margin: 0 auto;
  `}

  ${customMedia.lessThan('md')`
    padding: 48px 146px 0 146px;
    margin: 0;
  `}

  ${customMedia.lessThan('sm')`
    padding: 56px 0 0 0;
    max-width: 580px;
  `}

  ${customMedia.lessThan('xs')`
    padding: 29px 0 0 0;
  `}
`

export const FooterGrid = styled.div`
  display: flex;
  grid-template-columns: 1fr 4fr;
  grid-template-rows: auto 1fr;
  grid-template-areas: "logo link link link link";
  gap: 0 7.2rem;
  margin-bottom: 100px;

  ${customMedia.lessThan('md')`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto 1fr;
    grid-template-areas:
                "logo logo logo logo"
                "link link link link";
    gap: 0 1.2rem;
  `}

  ${customMedia.lessThan('sm')`
    grid-template-columns: none;
    display: flex;
    width: 100%;
    margin-bottom: 0;
    flex-direction: column;
  `}
`

export const FooterGridSocials = styled.div`
  display: flex;
  @media only screen and (max-width:600px) {
    flex-direction: column-reverse
  }
`

export const FooterGridCopyright = styled.div`
  border-top: 1px solid ${props => props.theme.footer.desktop.copyright.line};
  display: grid;

  ${customMedia.lessThan('sm')`
    line-height: 5px;
    text-align: center;
    border-top: 1px solid ${props => props.theme.footer.mobile.copyright.line};
    padding-top: 10px;
  `}

  ${customMedia.lessThan('xs')`
    text-align: left;
  `}
`

export const DasaFooterLogo = styled.img`
  width: 143px;
  height: 34px;

  ${media.lessThan('medium')`
    width: 94px;
    height: 22px;
    grid-column: 1/3;
    grid-row: 1;
    margin-bottom: 3.6rem;
  `}
`

export const Certification = styled.div`
  width: 100%;
  padding-bottom: 35px;
  align-items: center;
  display: flex;
  font-family: ${props => props.theme.font};
  font-size: 14px;
  line-height: 170%;
  color: ${props => props.theme.footer.desktop.copyright.text};

  ${media.lessThan('medium')`
    color: ${props => props.theme.footer.mobile.copyright.text};
  `}

`

export const TechnicalManager = styled.p`
  grid-column: 2/6;
  font-size: 1.6rem;
  font-weight: 600;
  margin: 4rem 0;

  ${media.between('medium', 'huge')`
    font-size: 1.4rem;
    margin: 2.4rem 0;
  `}

  ${media.lessThan('medium')`
    grid-column: 1/3;
    grid-row: 7;
  `}
`

export const LogoContainer = styled.div`
  ${customMedia.lessThan('sm')`
    width: 94px;
    height: 22px;
    grid-column: 1/3;
    grid-row: 1;
    padding: 0 0 60px 0;
  `}

  ${customMedia.lessThan('md')`
    padding: 0 0 56px 0;
  `}

  ${customMedia.lessThan('sm')`
    padding: 0 0 56px 110px;
  `}

  ${customMedia.lessThan('xs')`
    padding: 0 0 50px 24px;
  `}
`

export const LogoBrand = styled(Logo)`
  width: 143px;
  height: 34px;
  grid-area: logo;
`

export const LinksContainer = styled.div`
  display: grid;
  grid-area: link;
  grid-template-columns: repeat(4, 1fr);
  gap: 0 3.2rem;

  ${customMedia.lessThan('md')`
    gap: 0 1.2rem;
  `}

  ${customMedia.lessThan('sm')`
    grid-template-columns: none;
  `}
`
